/* eslint-disable */
export default {
  searchPlaceholder: '搜尋...',
  refresh: '重新整理',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
